import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight, faCaretLeft } from "@fortawesome/pro-solid-svg-icons";
import { useRef } from "react";
const ScrollTable = ({ children, header, body, className, isLoading }) => {
  const tableRef = useRef();
  return (
    <div className="d-flex align-center">
      <div
        className="fs-40 clickable mr-20"
        onClick={() => {
          tableRef.current.scrollLeft -= 100;
        }}
      >
        <FontAwesomeIcon icon={faCaretLeft} color="#D9D9D9" />
      </div>
      <table className="scroll-table mb-4" ref={tableRef}>
        <thead>
          <tr className="trhead">
            {header
              ? header.map((item, index) => {
                  return <th className="thcell">{item}</th>;
                })
              : body.map((item, index) => {
                  return <th className="thcell">{`Field ${index + 1}`}</th>;
                })}
          </tr>
        </thead>
        <tbody>
          <tr className="trbody">
            {body.map((item, index) => {
              return <td className="tdcell">{item}</td>;
            })}
          </tr>
        </tbody>
      </table>
      <div
        className="fs-40 clickable ml-20"
        onClick={() => {
          tableRef.current.scrollLeft += 100;
        }}
      >
        <FontAwesomeIcon icon={faCaretRight} color="#D9D9D9" />
      </div>
    </div>
  );
};

export default ScrollTable;
